import React, { useState  , Fragment} from 'react'
import "./utils.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { STATUS } from '../../Constants';
import PostPageComponent from '../PageComponents/PostPageComponent';
import PostLoaddingComponent from '../PageComponents/PostLoaddingComponent';
import { useDispatch, useSelector } from 'react-redux';
import {  getSavedPostsIds, selectAll, selectAllPostDetails } from '../../RTK/Slice/GroupData/CollectSlice';
import { Button } from '@mui/material';

const ListPosts = ({posts=[] , until='' , showNonZero=true , hasNextHandler , hasNext='',  selectAllOption =true , status=STATUS.IDLE , hideAddPost=false ,hideSearch=false  }) => {

    // For Translation
    const {t} = useTranslation() ; 

    // For Select non zero
    const [nonZero , setNonZero] = useState(false) ; 

    // For Dispatch Action
    const dispatch = useDispatch() ;

    // For Search for post 
    const [search , setSearch] = useState('') ;


    // For Handle Search for posts
    const searchPostHandler = (e)=>{
      setSearch(e.target.value) ;
    }


    // For Select All Posts
    const selectAllHandler = ()=>{
      if(nonZero){
        const postsIds = posts.filter(item => item.comments.summary.total_count !==0 ).map((item)=>item.id)
        dispatch(selectAll(postsIds)) ;
        dispatch(selectAllPostDetails(posts.filter(item=>item.comments.summary.total_count !== 0 ))) ;  
      }else{
        const postsIds = posts.map((item)=>item.id)
      dispatch(selectAll(postsIds)) ;
      dispatch(selectAllPostDetails(posts)) ;  
      }
    }

    const savedPosts = useSelector(getSavedPostsIds);

    // For Change non zero handler
    const changeNonZeroHandler = ()=>{
      setNonZero(!nonZero) ; 

    }



  return (
    <div className='all-post-page' style={{paddingTop : "5px"}}>

          <div className='list-posts-tools'>
            {
              selectAllOption ? 
              (<button onClick={selectAllHandler} className='select-all-btn'>Select All</button>) 
              :
              ""
            }
            {
              showNonZero ? 
              <div className='non-zero'>
                <p>Non-zero posts</p>
                <div onClick={changeNonZeroHandler} className={ `non-slider`}> <span className={`ball-slide  ${nonZero ? 'ball-active' :""}`}></span> </div>
              </div>
              :""
            }
            

          </div>
          
          
          
          {
            !hideAddPost ? 
            (
              <div className='search-barf' >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
                <input onChange={searchPostHandler} placeholder={"Search"} />
              </div>

            ) :""
          }
          

          {/*
            status === STATUS.LOADDING ?
            (
              <Fragment>
                <PostLoaddingComponent />
                <PostLoaddingComponent />
                <PostLoaddingComponent />
              </Fragment>
              
            ) :""
          */}


        {
            
            posts.length > 0 ?
            posts
            .filter(item=> nonZero?item.comments.summary.total_count !==0   :item)
            .filter((item)=>search === '' ? item : item?.message?.toLowerCase().includes(search) )
            .map((item , idx)=>{
              return ( <PostPageComponent  selected={savedPosts.includes(item.id)?true : false} hideAddPost={hideAddPost} key={idx} allData={item} postId={item?.id} pageName={item?.from?.name} pagePic={item?.from?.picture?.data?.url} date={item?.created_time?.slice(0 , 10)} content={item?.message} numComment={item?.comments?.summary?.total_count} postPic={item?.attachments?.data[0]?.media?.image?.src ? item?.attachments?.data[0]?.media?.image?.src : ""} />
              )
            }) 
            :
            (<h2>No Posts</h2>)
              
            
            
          }

          {/*
            posts.length === 0  && status === STATUS.IDLE ? 
            <h2>No Posts</h2>
            :""
          */}

          {
            status === STATUS.LOADDING ?
            (
              <Fragment>
                <PostLoaddingComponent />
                <PostLoaddingComponent />
                <PostLoaddingComponent />
              </Fragment>
              
            ) :""
          }
          
          <div className="main-pagination" style={{maxWidth : "100%"}}>
            <div className="pagination-btn">
            </div>
            <div className="pagination-btn" >
                {hasNext ? (<Button disabled={status === STATUS.LOADDING} className="btn-pag" onClick={hasNextHandler} >  Next</Button>) : ""}
                
            </div>
          </div>
        
    </div>
  )
}

export default ListPosts
